module.exports = __webpack_public_path__ + "media/images/workplace/job_type_bg/job_type_background_mystery_visit-8bb41d53a87a708b0e4f02c672047807.svg";